document.addEventListener('click',e=>{const b=e.target.closest('[data-menu-toggle]');if(b){document.body.classList.toggle('menu-open')}});

(function(){
  function initHeroSlider(slider){
    const slides=[...slider.querySelectorAll('.hero-product-slide')];
    const dotsWrap=slider.querySelector('[data-slider-dots]');
    if(slides.length<2 || !dotsWrap) return;
    let index=0;
    const speed=parseInt(slider.dataset.speed || '3500',10);
    dotsWrap.innerHTML='';
    const dots=slides.map((_,i)=>{
      const dot=document.createElement('button');
      dot.className='slider-dot'+(i===0?' is-active':'');
      dot.type='button';
      dot.setAttribute('aria-label','Show product '+(i+1));
      dot.addEventListener('click',()=>show(i,true));
      dotsWrap.appendChild(dot);
      return dot;
    });
    function show(next,manual){
      slides[index].classList.remove('is-active');
      dots[index].classList.remove('is-active');
      index=next;
      slides[index].classList.add('is-active');
      dots[index].classList.add('is-active');
      if(manual){restart();}
    }
    function next(){show((index+1)%slides.length,false);}
    let timer=setInterval(next,speed);
    function restart(){clearInterval(timer);timer=setInterval(next,speed);}
    slider.addEventListener('mouseenter',()=>clearInterval(timer));
    slider.addEventListener('mouseleave',restart);
  }
  document.addEventListener('DOMContentLoaded',()=>document.querySelectorAll('[data-hero-slider]').forEach(initHeroSlider));
  document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-hero-slider]').forEach(initHeroSlider));
})();

(function(){
  function initGallery(gallery){
    const slides=[...gallery.querySelectorAll('[data-gallery-slide]')];
    const thumbs=[...gallery.querySelectorAll('[data-gallery-thumb]')];
    if(!slides.length || !thumbs.length) return;
    thumbs.forEach(thumb=>{
      thumb.addEventListener('click',()=>{
        const index=thumb.dataset.galleryThumb;
        slides.forEach(s=>s.classList.toggle('is-active',s.dataset.gallerySlide===index));
        thumbs.forEach(t=>t.classList.toggle('is-active',t.dataset.galleryThumb===index));
      });
    });
  }
  document.addEventListener('DOMContentLoaded',()=>document.querySelectorAll('[data-product-gallery]').forEach(initGallery));
  document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-product-gallery]').forEach(initGallery));
})();
